import React from 'react';
import  '../styles/ResearchQuestions.css';

export const QuestionWithYesNo = (props) => {
    return (
        <div className='single-question-container'>
            <span>{props.questionNumber}. {props.researchQuestion}</span>
            <div className="radio-buttons">
                <div>
                    <input
                        id="yes"
                        value="Y"
                        name={props.category}
                        type="radio"
                        onChange={props.handleOnChange}
                        required
                    />
                    <label>Yes</label>
                </div>
                <div>
                    <input
                        id="no"
                        value="N"
                        name={props.category}
                        type="radio"
                        onChange={props.handleOnChange}
                    />
                    <label>No</label>
                </div>
            </div>
        </div>
    );
}
